import { useTranslation } from 'react-i18next';

import {
  Form,
  TextInput,
  PLATFORM_THEME_COLORS,
  PhoneNumberInput,
} from '@thinknet-gmbh/platform-common-ui';

import { URL_REGEX } from '@thinknet-gmbh/platform-common';

import {
  PersonalInfoRow,
  SocialLinksContainer,
} from '../../personal-info.styles';
import { TitleRowLabel, StyledContainer } from '../../../employee-common.styles';

const ContactData = ({isOwnData}: { isOwnData?: boolean;}) => {
  const { t } = useTranslation(['common', 'employee']);

  return (
    <StyledContainer>
      <TitleRowLabel weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
        {t('employee:labels.contactData')}
      </TitleRowLabel>
      <PersonalInfoRow>
        <Form.Item name={'companyPhoneNumber'} label={t('employee:labels.companyPhoneNumber')}>
          <PhoneNumberInput disabled={isOwnData} placeholder="+49 176 384 15749" />
        </Form.Item>
        <Form.Item name={'phoneNumber'} label={t('employee:labels.personalPhoneNumber')}>
          <PhoneNumberInput disabled={isOwnData} placeholder="+49 176 384 15749" />
        </Form.Item>
        <Form.Item shouldUpdate>
          {() => (
            <Form.Item
              name={'email'}
              label={t('common:labels.email')}
              rules={[
                { required: true, message: t('common:validation.error.emailRequired') },
                { type: 'email', message: t('common:validation.error.incorrectFormat') },
              ]}
            >
              <TextInput disabled={isOwnData} maxLength={50} placeholder="kateonolov@gmail.com" />
            </Form.Item>
          )}
        </Form.Item>
        <Form.Item
          name={'personalEmail'}
          label={t('employee:labels.personalEmail')}
          rules={[
            { required: true, message: t('employee:validationError.personalEmailRequired') },
            { type: 'email', message: t('common:validation.error.incorrectFormat') },
          ]}
        >
          <TextInput disabled={isOwnData} maxLength={50} placeholder="kateonolov@gmail.com" />
        </Form.Item>
      </PersonalInfoRow>
      <SocialLinksContainer>
        <Form.Item
          name={['socials', 'linkedIn']}
          label="Linkedin"
          rules={[
            { required: false, message: t('customers:error.fieldIsRequired') },
            {
              pattern: URL_REGEX,
              message: t('common:validation.error.urlFormat'),
            },
          ]}
        >
          <TextInput maxLength={100} placeholder="http://linkedin/...." />
        </Form.Item>
        <Form.Item
          name={['socials', 'xing']}
          label="XING"
          rules={[
            { required: false, message: t('customers:error.fieldIsRequired') },
            {
              pattern: URL_REGEX,
              message: t('common:validation.error.urlFormat'),
            },
          ]}
        >
          <TextInput maxLength={100} placeholder="http://xing/...." />
        </Form.Item>
      </SocialLinksContainer>
    </StyledContainer>
  );
};

export default ContactData;
